/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  GetAllTemplate: {},
  GetAllTemplateWithoutPagination: [],
}

export const getAllTemplate: any = createAsyncThunk(
  'getAllTemplate',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}template`, {
      params: {...data, withBase64Media: true},
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)
export const getAllTemplateWithoutPagination: any = createAsyncThunk(
  'getAllTemplateWithoutPagination',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}template/getWithoutPagination`, {
      params: {...data, withBase64Media: true},
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)
export const CreateNewTemplate: any = createAsyncThunk(
  'CreateNewTemplate',
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}template`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(getAllTemplate())
    return response.data
  }
)

export const DeleteTemplate: any = createAsyncThunk(
  'quickSms/DeleteTemplate',
  async (data, thunkApi) => {
    const response = await axios.delete(`${API_URL}template/${data}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(getAllTemplate())
    return response.data
  }
)
export const EditTemplate: any = createAsyncThunk(
  'quickSms/EditTemplate',
  async (data: any, thunkApi) => {
    const response = await axios.put(`${API_URL}template/${data?.id}`, data?.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(getAllTemplate())
    return response.data
  }
)
const TemplateSlice = createSlice({
  name: 'TemplateSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllTemplate.fulfilled, (state, action) => {
      return {...state, GetAllTemplate: action?.payload}
    })
    builder.addCase(getAllTemplateWithoutPagination.fulfilled, (state, action) => {
      return {...state, GetAllTemplateWithoutPagination: action?.payload}
    })
  },
})

export const getTemplateList = (state: any) => state?.Template?.GetAllTemplate?.data
export const getTemplateListWithoutPagination = (state: any) =>
  state?.Template?.GetAllTemplateWithoutPagination?.data

export default TemplateSlice.reducer
